import { render } from "./HeaderLayout.vue?vue&type=template&id=4f36c663"
import script from "./HeaderLayout.vue?vue&type=script&lang=js"
export * from "./HeaderLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/teacher/HeaderLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f36c663"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f36c663', __exports__)) {
    api.reload('4f36c663', __exports__)
  }
  
  module.hot.accept("./HeaderLayout.vue?vue&type=template&id=4f36c663", () => {
    api.rerender('4f36c663', render)
  })

}


export default __exports__